module.exports = __webpack_public_path__ + "static/media/play-button.0d5f7f53.svg";